import { TInitiateEmailChangeReq } from "@sharedTypes/req.type";
import { TInitiateEmailChangeRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function InitiateEmailChange(newEmail: string, oldEmail: string, password: string) {
  const apiUrl = "/email/initiateemailchange";

  const body: TInitiateEmailChangeReq = {
    newEmail,
    oldEmail,
    password,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TInitiateEmailChangeRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
